/**
 * The "Rides | All" choice of the rides list and calendar
 * (docs/ACTIVITIES_PLAN.md §4), remembered on this device. Always
 * ``rides`` while other activities are off for the user.
 */
import { useActivitiesEnabled } from './usePlan.ts';
import type { RideScope } from './useRides.ts';
import { useStoredChoice } from './useStoredChoice.ts';

export const RIDE_SCOPE_KEY = 'rides_scope';
const SCOPES: readonly RideScope[] = ['rides', 'all'];

export function useRideScope(): {
  enabled: boolean;
  scope: RideScope;
  setScope: (scope: RideScope) => void;
} {
  const enabled = useActivitiesEnabled();
  const [stored, setScope] = useStoredChoice<RideScope>(RIDE_SCOPE_KEY, SCOPES, 'rides');
  return { enabled, scope: enabled ? stored : 'rides', setScope };
}
